<template>
	<div
		class="one-slot-offer-card-detail template-layout premium-shop-item__content"
	>
		<div class="premium-shop-item__character-wrapper">
			<div
				class="premium-shop-item__character-image"
				:class="`character--${contentData.attributes?.skin}-140`"
			/>
		</div>
		<div
			class="premium-shop-item__values"
			:class="{
				'premium-shop-item__values--offset-right': true,
			}"
		>
			<div class="premium-shop-item__values-ribbon">
				<span>{{ translate("ui.extra_rewards") }}</span>
			</div>
			<span class="premium-shop-item__values-text">
				{{ translate(`offer.lok_${eventAttributes.type}_pass`) }}
			</span>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { useEventStore } from "@/event";
import { type ShopItem } from "@/types/shop";
import { translate } from "@/utils/translate";
import { storeToRefs } from "pinia";

interface Props {
	contentData: ShopItem;
}

const { contentData } = defineProps<Props>();

const eventStore = useEventStore();
const { attributes: eventAttributes } = storeToRefs(eventStore);
</script>

<style lang="scss" scoped>
.premium-shop-item__content {
	position: relative;
	flex: 1 1 auto;
	width: 100%;
	min-height: 0;
	@include flex-row-center;
	align-items: flex-end;
	height: 100%;

	.premium-shop-item {
		&__character {
			&-wrapper {
				position: relative;
				flex: 0 0 auto;
				width: 8.5rem;
				height: 9.5rem;
			}

			&-image {
				position: absolute;
				bottom: 0;
				left: 0;
			}
		}

		&__values {
			flex: 1 1 auto;
			@include flex-col-center;
			justify-content: flex-start;
			padding-bottom: 2.5rem;
			height: 100%;
			overflow: hidden;

			&--offset-right {
				@include flex-col-center;
				gap: 0.375rem;
				padding-right: 1.75rem;
				min-height: 10.75rem;
			}

			.rewards-grid {
				width: 100%;
			}

			&-ribbon {
				width: 12.625rem;
				height: 1.875rem;
				@include background(
					url($path-images + "shop/backgrounds/golden-center-ribbon.avif"),
					contain,
					center,
					no-repeat
				);
				@include flex-row-center;
				z-index: 2;
				color: #fff3dd;
				font-weight: 800;
				font-size: 0.875rem;
				line-height: 1;
				text-shadow: 0.044rem 0.044rem 0.063rem rgba(0, 0, 0, 0.6);
				text-transform: uppercase;
			}

			&-text {
				@include flex-row-center;
				width: 100%;
				color: #fff;
				font-size: 0.8125rem;
				text-align: center;
				text-shadow: 0.044rem 0.044rem 0.063rem rgba(0, 0, 0, 0.6);
			}
		}
	}
}
</style>
